import { DateTime } from 'luxon';
import { Fieldset, Input } from '@flixbus/honeycomb-react';

import { toISODateEndOfDay } from '../../../../helpers/dateTime';

import { useVoucherFormContext } from '../../Context';

import { TravelPeriodRule } from '../../../../types/Rules';

const UntilDate = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const ruleValue = rules.filter(r => r.type === 'travel_period')[0] as
    | TravelPeriodRule
    | undefined;

  const dateObject = ruleValue?.end ? DateTime.fromISO(ruleValue.end) : null;

  return (
    <Fieldset itemSpacing='half'>
      <Input
        name='rule-valid-until-input'
        id='rule-valid-until-input'
        label={<>Travel departure until</>}
        type='date'
        min={new Date().toString()}
        info={`The travel validity ends at 23:59 GMT${DateTime.local().toFormat('ZZ')}`}
        required
        value={dateObject ? dateObject.setLocale('de').toFormat('yyyy-MM-dd') : ''}
        onChange={e => {
          const { value } = e.target;

          if (value === '') {
            // Remove the rule
            handleRuleChange(
              {
                type: 'travel_period',
                ...ruleValue,
                end: '',
              },
              true,
            );
          } else {
            const date = new Date(value);
            handleRuleChange({
              type: 'travel_period',
              ...ruleValue,
              end: toISODateEndOfDay(DateTime.fromJSDate(date)),
            });
          }
        }}
      />
    </Fieldset>
  );
};

export default UntilDate;
